import { call } from 'redux-saga/effects';

export function* getColumnAndFilterGridTable(gridColInfoApiService, param) {
  const response = yield call(gridColInfoApiService, param.gridName);

  return response;
}
